import {FeatureReferenceBinding} from '../../feature/binding/FeatureReferenceBinding';
import {ModelTopologyFeatureBinding} from '../../feature/binding/ModelTopologyFeatureBinding';
import {SketchProfileFeatureBinding} from '../../feature/binding/SketchProfileFeatureBinding';
import {SketchSubEntityFeatureBinding} from '../../feature/binding/SketchSubEntityFeatureBinding';
import {ExtrudeReferenceFeatureBinding} from '../../feature/binding/ExtrudeReferenceFeatureBinding';

/**
 * 根据载荷创建特征引用绑定。
 * @param payload 序列化载荷。
 * @returns 运行时绑定对象。
 */
export function createFeatureReferenceBinding(payload: SerializedFeatureReferenceBinding): FeatureReferenceBinding {
    if (payload.kind === 'extrude-reference') return new ExtrudeReferenceFeatureBinding(payload);
    if (payload.kind === 'sketch-profile') {
        return new SketchProfileFeatureBinding(payload);
    }
    if (payload.kind === 'sketch-sub-entity') {
        return new SketchSubEntityFeatureBinding(payload);
    }
    if (payload.kind === 'model-topology') {
        return new ModelTopologyFeatureBinding(payload);
    }
    throw new Error(`未支持的特征引用绑定类型：${String((payload as {kind?: string}).kind)}`);
}
